import camelcaseKeys from 'camelcase-keys';

export const getters = {
  getPayments($state) {
    return $state.sortOrder.map(paymentId => $state.records[paymentId]);
  },
  getPaymentsList($state) {
    const payments = $state.sortOrder.map(paymentId => $state.records[paymentId]);
    return camelcaseKeys(payments, { deep: true });
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getPayment: $state => id => {
    const payment = $state.records[id];
    return payment || {};
  },
  getMeta: $state => {
    return $state.meta;
  },
};
